import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { showToast } from '@klpkonsern/ui';

import { useCreateProsjektProcessMutation } from '@klp/prosjekt/services/rtkApi';
import { ProsjektRoutes } from '@klp/prosjekt/config';
import type { PROSJEKT_TYPE } from '@klp/formgenerator/interfaces';

export const useStartProsess = () => {
    const [createProsjekt, { isLoading }] = useCreateProsjektProcessMutation();
    const history = useHistory();
    const { t } = useTranslation();

    const startProcess = async (
        type: PROSJEKT_TYPE,
        superOfficeProsjektId: string,
        steg: number,
        prosjektskjemaType: number,
        rekkefolgenummer: number,
    ) => {
        try {
            const d = await createProsjekt({
                type,
                steg,
                superOfficeProsjektId,
                prosjektskjemaType,
                rekkefolgenummer,
            }).unwrap();

            showToast({
                body: t('prosjekt.successfulOperation'),
                type: 'success',
            });

            if (d.prosessInstansId && d.prosjektId) {
                history.push(
                    ProsjektRoutes.projectSchemaSingle(
                        d.prosessInstansId,
                        d.prosjektId,
                    ),
                );
            }
        } catch {
            showToast({ body: t('general.error.message'), type: 'error' });
        }
    };

    return { startProcess, isLoading };
};
